import { ref } from 'vue'
import { defineStore } from 'pinia'
import { Snack, SnackbarManager, SnackColor, SnackDelay } from '@internal-libraries/kheops-ui-lib'
import { ClvrHttpClientError } from '../Type'
import { useTranslate } from '../i18n/useTranslation'

// @TODO in ui-lib, add snack type to only have one function hook with object as parameter
type SnackType = {
    message: string
    color: SnackColor
    delay: SnackDelay
}
export const useSnackStore = defineStore('snack', () => {
    const snackbarManager = ref<SnackbarManager>()
    const $t = useTranslate()

    const getApiErrorMsg = (error: ClvrHttpClientError): string => {
        return 'response' in error ? error.response.data.errors.message : error.message
    }

    const manageApiError = (error: ClvrHttpClientError): void => {
        addErrorSnack(getApiErrorMsg(error), true)
    }

    const addErrorSnack = (message = 'clevehr:common-error_occured', onInstance = false): void => {
        addSnack({ message: message, color: SnackColor.error, delay: SnackDelay.medium }, onInstance)
    }

    const addWarningSnack = (message = '', onInstance = false): void => {
        addSnack({ message: message, color: SnackColor.warning, delay: SnackDelay.medium }, onInstance)
    }

    const addSuccessSnack = (message = '', onInstance = false): void => {
        addSnack({ message: message, color: SnackColor.success, delay: SnackDelay.medium }, onInstance)
    }

    const addSnack = (snackData: SnackType, onInstance = false): void => {
        const attachedSnackbarManager = window.attachedVue?.snackbarManager
        const snackbarManagerUsed =
            onInstance && attachedSnackbarManager ? attachedSnackbarManager : snackbarManager.value

        snackbarManagerUsed?.addSnack(new Snack($t.value(snackData.message), snackData.color, snackData.delay))
    }

    return {
        snackbarManager,
        getApiErrorMsg,
        manageApiError,
        addErrorSnack,
        addWarningSnack,
        addSuccessSnack,
        addSnack,
    }
})
